/* eslint-disable react/jsx-props-no-spreading */
import {
  Avatar,
  Text,
  UnstyledButton,
  UnstyledButtonProps,
} from "@mantine/core";
import { ChevronDownIcon } from "lucide-react";
import { motion } from "motion/react";

interface UserButtonProps extends UnstyledButtonProps {
  image?: string;
  name?: string;
  email?: string;
  icon?: React.ReactNode;
  minimized?: boolean;
}

const UserButton = ({
  image, name, email, icon, minimized = false, ...others
}: UserButtonProps) => (
    <UnstyledButton
      w={minimized ? undefined : "100%"}
      className={minimized
        ? "mx-auto h-7 w-7 rounded-[5px] flex items-center justify-center hover:bg-sidebar-hover transition-colors"
        : "rounded-[5px] px-1 py-1.5 hover:bg-sidebar-hover transition-colors"}
      {...others}
    >
      <div className={`flex w-full items-center ${minimized ? "justify-center" : "gap-2"}`}>
        <Avatar size={20} variant="filled" src={image} color="black" radius="sm">
          {name?.charAt(0)}
        </Avatar>

        {!minimized && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="flex justify-between items-center flex-1 min-w-0"
          >
            <Text truncate fw={500} className="flex-1 text-[13px]">
              {name}
            </Text>
          </motion.div>
        )}

        {!minimized ? (icon || (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.15 }}
            >
                <ChevronDownIcon size="0.9rem" className="shrink-0 text-sidebar-text" />
            </motion.div>
        )) : ""}
      </div>
    </UnstyledButton>
);

export default UserButton;
